"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

var _Select = _interopRequireDefault(require("../../components/Select"));

var _redux = require("../../redux"); // import app components


var EditorSettings = function EditorSettings(props) {
  var _editorSite$editorOpt, _editorSite$editorOpt2, _editorSite$editorOpt3, _editorSite$editorOpt4, _editorSite$editorOpt5, _editorSite$editorOpt6;

  var onChange = props.onChange,
      onUpdate = props.onUpdate,
      loading = props.loading;

  var _ref = (0, _redux.useAppSelector)(function (state) {
    return state;
  }),
      editorSite = _ref.cms.editor.site;

  var handleChange = function handleChange(name, value) {
    return onChange(name, value);
  };

  var handleUpdate = function handleUpdate() {
    return onUpdate({
      editorOptions: editorSite === null || editorSite === void 0 ? void 0 : editorSite.editorOptions
    }, 'editor');
  };

  return /*#__PURE__*/_react.default.createElement(_antd.Card, {
    title: 'Sidebar'
  }, /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: "vertical",
    size: 20
  }, /*#__PURE__*/_react.default.createElement(_Select.default, {
    label: "Position",
    value: editorSite === null || editorSite === void 0 ? void 0 : (_editorSite$editorOpt = editorSite.editorOptions) === null || _editorSite$editorOpt === void 0 ? void 0 : (_editorSite$editorOpt2 = _editorSite$editorOpt.sidebar) === null || _editorSite$editorOpt2 === void 0 ? void 0 : _editorSite$editorOpt2.position,
    onChange: function onChange(v) {
      return handleChange('editorOptions.sidebar.position', v);
    }
  }, /*#__PURE__*/_react.default.createElement(_antd.Select.Option, {
    value: "left",
    children: "Left"
  }), /*#__PURE__*/_react.default.createElement(_antd.Select.Option, {
    value: "right",
    children: "Right"
  })), /*#__PURE__*/_react.default.createElement(_Select.default, {
    label: "Style",
    value: editorSite === null || editorSite === void 0 ? void 0 : (_editorSite$editorOpt3 = editorSite.editorOptions) === null || _editorSite$editorOpt3 === void 0 ? void 0 : (_editorSite$editorOpt4 = _editorSite$editorOpt3.sidebar) === null || _editorSite$editorOpt4 === void 0 ? void 0 : _editorSite$editorOpt4.style,
    onChange: function onChange(v) {
      return handleChange('editorOptions.sidebar.style', v);
    }
  }, /*#__PURE__*/_react.default.createElement(_antd.Select.Option, {
    value: "inline",
    children: "Inline"
  }), /*#__PURE__*/_react.default.createElement(_antd.Select.Option, {
    value: "overflow",
    children: "Overflow"
  }), /*#__PURE__*/_react.default.createElement(_antd.Select.Option, {
    value: "scale",
    children: "Scale"
  })), /*#__PURE__*/_react.default.createElement(_Select.default, {
    label: "Default Status",
    value: editorSite === null || editorSite === void 0 ? void 0 : (_editorSite$editorOpt5 = editorSite.editorOptions) === null || _editorSite$editorOpt5 === void 0 ? void 0 : (_editorSite$editorOpt6 = _editorSite$editorOpt5.sidebar) === null || _editorSite$editorOpt6 === void 0 ? void 0 : _editorSite$editorOpt6.defaultOpen,
    onChange: function onChange(v) {
      return handleChange('editorOptions.sidebar.defaultOpen', v);
    }
  }, /*#__PURE__*/_react.default.createElement(_antd.Select.Option, {
    value: 'true',
    children: "Open"
  }), /*#__PURE__*/_react.default.createElement(_antd.Select.Option, {
    value: 'false',
    children: "Closed"
  })), /*#__PURE__*/_react.default.createElement(_antd.Button, {
    loading: loading === 'editor',
    onClick: handleUpdate,
    children: "Update",
    type: "primary"
  })));
};

var _default = EditorSettings;
exports.default = _default;